import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

const storedLang =
  typeof window !== 'undefined' ? window.localStorage.getItem('lb_lang') : null;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: storedLang || 'ar',
    fallbackLng: 'ar',
    supportedLngs: ['ar', 'en'],
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

/** Applies the correct writing direction for the active language. */
export function applyDocumentDirection(lang: string) {
  if (typeof document === 'undefined') return;
  const isArabic = lang.startsWith('ar');
  document.documentElement.setAttribute('dir', isArabic ? 'rtl' : 'ltr');
  document.documentElement.setAttribute('lang', isArabic ? 'ar' : 'en');
}

applyDocumentDirection(i18n.language || 'ar');

export default i18n;